import { Injectable } from '@angular/core';
import { FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { LoanService } from './loan.service';

@Injectable()
export class LoansValidationService {
  constructor(private _loanService: LoanService) {}

  validateAgainstOutstandingAmount(accControlName, amountControlName): ValidatorFn {
    return (
      control: AbstractControl
    ):
    ValidationErrors | null => {
      let formGroup = control.parent;
        if(formGroup?.value[accControlName] && formGroup?.get(amountControlName) && control.value.amount) {
        let outstandingAmount = this._loanService.getLoanDetails(formGroup.value[accControlName])?.outstandingAmount;
            if(control.value.amount <= outstandingAmount){
                return null;
            }
            else {
                let error: any = {};
                error['Amount is greater than Outstanding amount'] = true;
                formGroup.get(amountControlName).markAsTouched();
                return error;
            }
        }
    };
  }
}
